import { computed } from 'vue';
import { useStore } from 'vuex';

export function useDigitalHumanAiMenuItem() {
    const store = useStore();

    const hasDHPermission = computed(() => store.getters['dh/hasPermission']);

    const digitalHumanAiMenuItems = computed(() => ({
        list: [
            {
                id: '__digital_human_ai',
                label: 'Digital human ai',
                permissionChecker: hasDHPermission.value,
                items: [
                    {
                        icon: 'file-text',
                        label: 'Document ingestion',
                        id: 'knowledge_library.index',
                    },
                    {
                        icon: 'refresh-ccw',
                        label: 'Conversation topics & settings',
                        id: 'digital_human_ai_settings.index',
                    },
                    {
                        icon: 'price',
                        label: 'Unit availability & pricing',
                        id: 'dh.availability_pricing.index',
                    },
                ],
            },
        ],
    }));

    return { digitalHumanAiMenuItems };
}
